import { RoomFlagNames, RoomFlags } from '../types';
export function setRoomFlag(flags, toSet) {
    if (!Array.isArray(toSet)) {
        toSet = [
            toSet
        ];
    }
    toSet.forEach((flagName)=>{
        const key = flagName.toLowerCase();
        if (Object.prototype.hasOwnProperty.call(RoomFlagNames, key)) {
            flags |= RoomFlags[key];
        }
    });
    return flags;
}

//# sourceMappingURL=setRoomFlag.js.map